import script from "./PathologyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PathologyCard.vue?vue&type=script&setup=true&lang=js"

import "./PathologyCard.vue?vue&type=style&index=0&id=e0de0ca2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0de0ca2"]])

export default __exports__